import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    bannerList: () => {
        return HTTP.get('/banner_list', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}